/**
 * @generated SignedSource<<8638b88261aaf386ac322c9e9cd3b770>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerIncentives_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useCoreBuyerIncentives_viewer">;
  readonly " $fragmentType": "BuyerIncentives_viewer";
};
export type BuyerIncentives_viewer$key = {
  readonly " $data"?: BuyerIncentives_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerIncentives_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerIncentives_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useCoreBuyerIncentives_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c9580ebb40f500c764dfcf2a6584bda1";

export default node;
